import { transformSeries } from './utils';
import translator from '@/locales';

export default function installHealthTransformer({ primaryChart }) {
  const series = transformSeries(primaryChart);
  const options = {
    chart: {
      type: 'column',
    },
    plotOptions: {
      column: {
        stacking: 'normal',
      },
    },
    tooltip: {
      useHTML: true,
      pointFormatter() {
        const currentSeries = series[this.series.index];
        const pointIndex = this.index;
        const pointDetails = currentSeries.details?.[pointIndex];
        const valueTitlePostfix = currentSeries.dataTitlePostfix || '';

        let output = `
          <div dir="${translator.t('HTML_DIR')}" style="margin-bottom: 8px;">
            <span style="color:${this.color}">\u25CF</span>
            <strong style="color:${this.color}">${currentSeries.name}: </strong>
            <span>${this.y}</span><span>${valueTitlePostfix}</span><br>`;

        if (pointDetails && Object.keys(pointDetails).length) {
          for (const [name, value] of Object.entries(pointDetails)) {
            output += `
            <div>
              <span dir="${translator.t('HTML_DIR')}">${name}: </span>
              <span>${value}</span>
            </div>`;
          }
        }

        output += '</div>';
        return output;
      },
      shared: false,
    },
  };
  return { series, options };
}
